import styled from 'styled-components';
import { ImageButtonStyled } from '../ImageButtonStyled';
import { rem } from 'polished';

export const ImageButtonStyledDS = styled(ImageButtonStyled)`
    .img-btn-container {
        border: ${rem('1px')} solid ${({ theme }) => theme.colors.coffeeDisabled};
        color: ${({ theme }) => theme.colors.black};
        text-decoration: none;
        padding: 0;
        justify-content: space-between;

        h1 {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        &.inactive {
            background-color: ${({ theme }) => theme.colors.accordionAnswer};
            color: ${({ theme }) => theme.colors.brown7};

            .description::after {
                display: none;
            }
        }

        &.active {
            color: ${({ theme }) => theme.colors.black};

            .description {
                background-color: ${({ theme }) => theme.colors.myAccountImageButtonDescriptionBackground};

                :after {
                    display: none;
                }
            }
        }

        .top {
            justify-content: flex-start;
            padding: ${rem('15px')} ${rem('20px')} ${rem('20px')};

            h1 {
                width: auto;
                display: inline-block;
            }

            .sum {
                height: ${rem('24px')};
                width: ${rem('24px')};
                min-width: ${rem('24px')};
                line-height: ${rem('24px')};
                background: ${({ theme }) => theme.colors.white};
                border: 1px solid ${({ theme }) => theme.colors.coffeeDisabled};
                color: ${({ theme }) => theme.colors.black};
                margin: 0 0 0 ${rem(10)};
                position: initial;
            }
        }

        .description {
            position: relative;
            padding: ${rem('11px')} ${rem('24px')};
            text-transform: uppercase;
            color: ${({ theme }) => theme.colors.white};
        }

        img {
            margin-bottom: ${rem('10px')};
            max-height: unset;
        }
    }
`;
